import { SUPPORT_URL } from '@mote/helpers/constants'
import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const FixMicrophonePermissionError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='It looks like you need to fix something'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          It looks like your microphone is blocked. You'll need to fix this in
          Chrome's settings. Search 'microphone blocked' on our Help site for
          more information.
        </Text>
      }
      buttons={
        <>
          <Button
            onClick={() => onClose()}
            variant='secondary'
            text='Dismiss'
          />
          <Button
            onClick={() => {
              window.open(SUPPORT_URL, '_blank')
            }}
            text='Learn more'
          />
        </>
      }
    />
  )
}
